<template>
	<FooterBar
		:link-items="linkItems"
		light
		hide-logo
		hide-social-media-links
	>
		<div class="d-flex justify-center align-center">
			<img
				alt="Ministère de la santé et MSA : Santé, Famille, Retraite, Services"
				class="ml-8 my-auto"
				src="/img/logos.png"
				width="238"
			>
		</div>
	</FooterBar>
</template>

<script lang="ts">
	import { LinkItem } from '@cnamts/vue-dot/src/patterns/FooterBar/types';
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component
	export default class AppFooter extends Vue {

		linkItems: LinkItem[] = [
			{
				text: 'Contacts',
				to: window.URL_CONTACT
			},
			{
				text: 'Mentions légales et CGU',
				to: {
					name: window.URL_LEGAL_MENTION
				}
			},
			{
				text: 'Gestion des cookies',
				to: {
					name: window.URL_LEGAL_MENTION,
					hash: window.URL_CGU_COOKIES
				}
			},
			{
				text: 'Données personnelles',
				to: {
					name: window.URL_LEGAL_MENTION,
					hash: window.URL_CGU_PERSONAL_DATA
				}
			},
			{
				text: 'Accessibilité : partiellement conforme',
				href: window.URL_ACCESSIBILITY ? '/' + window.URL_ACCESSIBILITY : ''
			}
		].filter(value => value.to !== '' && value.href !== '');
	}
</script>
